<template>
  <div v-loading="loading" class="talent-matrices">

    <div class="matrix-block">
      <div class="filters-before-table">
        <search-input
          placeholder="Поиск по названию"
          style="width: 300px"
          v-model="filters.search"
          @change="filtersChanged"
        >
        </search-input>
      </div>

      <el-table :data="matrices">
        <el-table-column prop="name" label="Название" width="500">
          <template v-slot="scope">
            <router-link
              class="table-router-link"
              :to="{ name: 'TalentMatrix', params: { id: scope.row.id } }"
              target="_blank"
            >
              {{ scope.row.name }}
            </router-link>
          </template>
        </el-table-column>
        <el-table-column prop="description" label="Описание"></el-table-column>
        <el-table-column width="100" align="right">
          <template v-slot="scope">
            <div style="display: flex; justify-content: space-between">
              <el-button
                v-if="$canAndRulesPass(scope.row, 'talent_matrix.matrix_update')"
                class="table-action-button"
                size="mini"
                round
                icon="fas fa-pen"
                @click="onEditMatrix(scope.row)"
              >
              </el-button>
              <el-popconfirm
                v-if="$canAndRulesPass(user, 'talent_matrix.matrix_create')"
                confirm-button-text='Да'
                cancel-button-text='Нет'
                icon="el-icon-question"
                title="Вы уверены, что хотите скопировать матрицу?"
                @confirm="copyMatrix(scope.row)"
              >
                <el-button
                  slot="reference"
                  class="table-action-button"
                  size="mini"
                  round
                  icon="far fa-copy"
                >
                </el-button>
              </el-popconfirm>
              <el-popconfirm
                v-if="$canAndRulesPass(scope.row, 'talent_matrix.matrix_delete')"
                confirm-button-text='Да'
                cancel-button-text='Нет'
                icon="el-icon-question"
                title="Вы уверены, что хотите удалить матрицу талантов?"
                @confirm="deleteMatrix(scope.row)"
              >
                <el-button
                  slot="reference"
                  class="table-action-button"
                  size="mini"
                  round
                  icon="far fa-trash-alt"
                >
                </el-button>
              </el-popconfirm>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <paginator
      :paginator.sync="paginator"
      use-router-query-param
      @page-changed="loadMatrices"
    ></paginator>
  </div>
</template>

<script>
import Paginator from "@/components/Paginator";
import SearchInput from "@/components/filters/SearchInput.vue";
import {paginator} from "@/mixins/paginator";
import {mapGetters} from "vuex";

export default {
  name: "talent-matrices-component",
  components: {
    Paginator,
    SearchInput,
  },
  mixins: [paginator],
  props: {
    onEditMatrix: {
      type: Function,
      required: true
    }
  },
  computed:{
    ...mapGetters(['user'])
  },
  data() {
    return {
      loading: false,
      matrices: [],
      filters: {},
    }
  },
  beforeMount() {
    this.paginator.perPage = 10;
  },
  mounted() {
    this.loadMatrices();
  },
  methods: {
    loadMatrices() {
      this.loading = true;
      this.$api.talentMatrix.matrixSearch({
        ...this.filters,
        [this.paginator.param]: this.paginator.page,
        [this.paginator.paramPerPage]: this.paginator.perPage,
        expand: ['permissions'].join(),
      })
        .then(({data, paginator}) => {
          this.matrices = data.matrices;
          this.paginatorFill(paginator);
        })
        .finally(() => {
          this.loading = false;
        })
    },
    deleteMatrix(matrix) {
      this.loading = true;
      this.$api.talentMatrix.matrixDelete({
        ids: [matrix.id]
      })
        .then(data => {
          this.$notify.success({
            title: 'Удалено',
            message: 'Матрица талантов успешно удалена'
          });
        })
        .finally(() => {
          this.loadMatrices();
        })
    },
    copyMatrix(matrix) {
      this.loading = true;
      this.$api.talentMatrix.matrixCopy({
        matrix_id: matrix.id
      })
        .then(data => {
          this.$notify.success({
            title: 'Скопировано',
            message: 'Матрица талантов успешно скопирована'
          });
        })
        .finally(() => {
          this.loadMatrices();
        })
    },
    filtersChanged() {
      this.loadMatrices();
    }
  }
}
</script>

<style scoped lang="scss">
  .talent-matrices {

    .table-router-link {
      text-decoration: none;
    }
  }
</style>